import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";

import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import React, { FC } from "react";
import useQuery from "hooks/useQuery";
import SectionGridFilterCard from "./SectionGridFilterCard";
import { Helmet } from "react-helmet";
import SectionSliderRecommendation from "components/SectionSliderRecommendation/SectionSliderRecommendation";
import { useSearch } from "hooks/useFetch";
import ButtonTop from "shared/Button/ButtonTop";

export interface ListingPageProps {
  className?: string;
}

const ListingPage: FC<ListingPageProps> = ({ className = "" }) => {
  // eslint-disable-next-line
  const { result, name, page } = useQuery();
  const [data, loading, error] = useSearch(result);

  return (
    <div
      className={`nc-ListingCarPage relative overflow-hidden ${className}`}
      data-nc-id="ListingCarPage"
    >
      <Helmet>
        <title>
          {name
            ? `Sewa ${name} murah dan lengkap | Rentrips.id`
            : "Barang Sewa di Rentrips.id"}
        </title>
        <meta
          name="description"
          content={
            name
              ? `Sewa ${name} ya di Rentrips.id aja! Dapatkan berbagai promo menarik, diskon, dan penawaran terbaik dari Rentrips.id.`
              : `Temukan barang sewa dengan kualitas terbaik dan harga terjangkau hanya di Rentrips.id! Dapatkan berbagai promo menarik, diskon, dan penawaran terbaik dari Rentrips.id.`
          }
        />
      </Helmet>
      <BgGlassmorphism />

      <div className="container relative">
        {/* SECTION HERO */}
        {/* <SectionHeroArchivePage
          currentPage="Rental car"
          currentTab="Rental car"
          listingType={
            <>
              <i className="text-2xl las la-car"></i>
              <span className="ml-2.5">1512 cars</span> */}
        {/*Diubah jadi props */}
        {/* </>
          }
          className="pt-10 pb-24 lg:pb-32 lg:pt-28 "
        /> */}

        {/* SECTION */}
        <SectionGridFilterCard
          loading={loading}
          className="pb-24 lg:py-16"
          query={result}
          error={error}
          data={data}
          heading={name || "Barang Sewa"}
          page={page as number}
        />

        {/* SECTION 1 */}
        <div className="relative py-16">
          <BackgroundSection />
          <SectionSliderRecommendation
            heading="Barang-barang serupa lainnya"
            subHeading="Barang yang kemungkinan besar akan anda suka"
            itemPerRow={4}
            sliderStyle="style2"
          />
        </div>

        {/* SECTION */}
        <SectionSubscribe2 className="py-24 lg:py-32" />
        <ButtonTop />
      </div>
    </div>
  );
};

export default ListingPage;
